import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-e7f2604f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block pt-3" }
const _hoisted_2 = {
  key: 0,
  class: "h-75 d-flex justify-content-center align-items-center"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  id: "open-modal-product-change",
  expand: "block"
}, null, -1))

import {
  IonModal,
  IonIcon,
  IonSpinner,
  IonSearchbar,
} from '@ionic/vue';
import { close } from 'ionicons/icons';
import { ref } from 'vue';
import useCurrentShoppingSessionStore from '@/stores/shopping/currentShoppingSessionStore';
import { CartProduct, Product } from '@/services/flyingBlue';
import ProductCardAdd from '@/components/shopping/product/ProductCardAdd.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductModalSeach',
  props: {
  isOpen: Boolean,
  addToOtherProducts: Boolean,
  searchParams: {
    type: String,
    required: false,
    default: '',
  },
  categoryId: {
    type: Number,
    required: false,
    default: null,
  },
},
  emits: ['closeModal', 'productTap'],
  setup(__props) {

const props = __props;


const store = useCurrentShoppingSessionStore();
const products = ref([] as CartProduct[]);
const searchbar = ref();
const loading = ref(true);

const query = ref('');
query.value = '';

let timeout: any = null;

// Function to fetch products data
async function fetchProducts() {
  loading.value = true;
  products.value = [];

  if (query.value === '' && props.searchParams === '' && props.categoryId <= 0) {
    loading.value = false;
    return;
  }

  let productPromise = null;
  if (props.categoryId > 0) {
    if (query.value === '' && props.searchParams === '') {
      productPromise = await store.getProductsForCategory(props.categoryId, 1, 200);
    } else {
      productPromise = await store.findProductsForCategory(query.value === '' ? props.searchParams : query.value, props.categoryId);
    }
  } else {
    productPromise = await store.findItemsForCurrentStore(query.value === '' ? props.searchParams : query.value);
  }

  const productEntities: Product[] = productPromise.data;
  const cartProducts = productEntities.map((product) => ({
    id: 0,
    product,
    productId: product.id,
    price: product.price,
    name: product.name,
    qty: 1,
    other_product: props.addToOtherProducts,
  }));
  products.value = cartProducts;
  loading.value = false;
}

function initSearch() {
  products.value = [];
  query.value = '';
  searchbar.value.$el.setFocus();
  fetchProducts();
}

async function search(event: any) {
  query.value = event.target.value ?? '';
  clearTimeout(timeout);
  timeout = setTimeout(() => {
    fetchProducts();
  }, 500);
}


return (_ctx: any,_cache: any) => {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonModal), {
      ref: "modal",
      trigger: "open-modal",
      "is-open": __props.isOpen,
      "initial-breakpoint": "1",
      breakpoints: [0, 1],
      onDidDismiss: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('closeModal', null))),
      onDidPresent: initSearch,
      onWillPresent: _cache[4] || (_cache[4] = ($event: any) => (products.value = []))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_ion_toolbar, {
            color: "light",
            class: "pt-0 m-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonSearchbar), {
                ref_key: "searchbar",
                ref: searchbar,
                placeholder: "café, chocolat...",
                value: __props.searchParams,
                onKeyup: _cache[0] || (_cache[0] = ($event: any) => (search($event)))
              }, null, 8, ["value"]),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    color: "primary",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('closeModal')))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        slot: "icon-only",
                        icon: _unref(close)
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_unref(IonSpinner), { name: "crescent" })
              ]))
            : _createCommentVNode("", true),
          (!loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(products.value, (p, index) => {
                  return (_openBlock(), _createBlock(ProductCardAdd, {
                    key: `products-${index}`,
                    "cart-product": p,
                    "add-to-other-products": props.addToOtherProducts,
                    "truncate-product-name": false,
                    onAddProduct: ($event: any) => (_ctx.$emit('closeModal', p)),
                    onProductTap: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('productTap', $event)))
                  }, null, 8, ["cart-product", "add-to-other-products", "onAddProduct"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["is-open"]),
    _hoisted_4
  ], 64))
}
}

})